import { useContext } from 'react';
import {
  SalaryPassKeyContext,
  type SalaryPassKeyContextValue,
} from '@/contexts/SalaryPassKeyContext';

export function useSalaryPassKey(): SalaryPassKeyContextValue {
  const ctx = useContext(SalaryPassKeyContext);
  if (!ctx) {
    throw new Error('useSalaryPassKey must be used within a SalaryPassKeyProvider');
  }
  return ctx;
}
